import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import TopPage from './TopPage';
import reportWebVitals from './reportWebVitals';
import { getCurrentUser } from './lib/api/auth';

const Root = () => {
  const [showApp, setShowApp] = useState(false);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState();

  useEffect(() => {
    handleGetCurrentUser();
  }, [setCurrentUser]);

  const handleGetCurrentUser = async () => {
    try {
      const res = await getCurrentUser();

      if (res?.data.isLogin === true) {
        setIsSignedIn(true);
        setCurrentUser(res?.data.data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleStart = () => {
    setShowApp(true);
  };

  // 現在のURLパスを取得
  const currentPath = window.location.pathname;

  // /signin パスの場合は常にAppコンポーネントを表示
  if (currentPath === '/signin') {
    return <App />;
  }

  // それ以外のパスでは従来の条件分岐を使用
  return (
    <>
      {isSignedIn || showApp ? <App /> : <TopPage onStart={handleStart} />}
    </>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();